import { wechatLauncherUserService, wechatLauncherPlatformService,rjhyUser, wechatUserService, wechatPromotionService, wechatDomainQL} from './instance.js'

import {getSignHeader, getCommonHeaders, createNewGatwaySignWx} from '@/utils/getSignHeader.js'


export const transformRequest = [(data) => {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  ret = ret.slice(0, -1)
  return ret
}]

export const getUserByCode = async (code, originId) => {
  let params =  {
    code, originId
  }
  let headers = getSignHeader(params)
  headers['Content-Type'] = 'application/json'
  return await wechatLauncherPlatformService.get(`api/platform/auth/web/token/code`, {
    params, headers
  })
}

export const getMiniQrCode = async ({originId, scene, page}) => {
  let params =  {
    originId,
    scene,
    page
  }
  // let headers = getSignHeader(params)
  // headers['Content-Type'] = 'application/json'
  // return await wechatLauncherPlatformService1.get(`api/platform/auth/aCodeUnlimited`, {
  //   params, headers
  // })
  let headers = createNewGatwaySignWx(params, 'get')
  const res =  await wechatDomainQL.get(`/rjhy-wechat-platform/api/platform/auth/aCodeUnlimited`, { params, headers })
  return res.data
}

export const getSignature = async ({url, originId}) => {
  let params = {
    url, originId
  }
  // let headers = getSignHeader(params)
  // headers['Content-Type'] = 'application/json'
  // const res = await wechatLauncherPlatformService.get(`api/platform/auth/jsconfig`, {
  //   params,
  //   headers
  // })
  // console.log('getSignature~~', res.data.result)
  // return res.data.result
  let headers = createNewGatwaySignWx(params, 'get')
  const res =  await wechatDomainQL.get(`/rjhy-wechat-platform/api/platform/auth/jsconfig`, { params, headers })
  return res.data.result
}

export const getConfigService = async (params) => {
  // let headers = getSignHeader(params)
  // headers['Content-Type'] = 'application/json'
  // const res = await wechatLauncherDynamicService.get(`config/analysis`, {
  //   params, headers
  // })
  let headers = createNewGatwaySignWx(params, 'get')
  const res =  await wechatDomainQL.get(`/rjhy-dynamic/api/1/config/analysis`, { params, headers })
  if (res.data.code !== 1) return {}
  return res.data.data
}

export const rjhyUserLogin = async ({serverId, reffer, activityId, code, originId}) => {
  let params =  {
    serverId,
    reffer,
    activityId,
    originId,
    code,
    type: '1' // 1-公众号，2-小程序，3-app
  }
  let headers = getSignHeader(params)
  headers['Content-Type'] = 'application/json'
  return await wechatLauncherUserService.post(`/api/1/user/new/front/wx/login`, params, {headers})
}

export const getUserByToken = async (params) => {
  let headers = getSignHeader(params)
  const res = await rjhyUser.get('', {
    params, headers
  })
  return res && res.data
}

export const getUserByTempToken = async (params) => {
  let headers = getCommonHeaders(params)
  const res = await wechatDomainQL.get(`/rjhy-wechat-platform/api/platform/auth/web/temp/token/get`, {params, headers})

  return res && res.data
}

export const getUserByUnionId = async (params) => {
  let headers = getSignHeader(params)
  const res = await wechatUserService.get('', {
    params, headers
  })
  return res && res.data
}

export const querySubscribeApi = async (params) =>{
  let headers = getSignHeader(params)
  const res =  await wechatPromotionService.post(`/api/v1/weChat/subscribe/query/list`, params, {headers})
  return res.data
}

export const queryTemplateConfigInfoApi = async (params) => {
  let headers = getSignHeader(params)
  const res =  await wechatPromotionService.get(`/api/v1/weChat/subscribe/config/h5/query`, {
    params, headers
  })
  return res.data
}

export const queryUserSubscribe = async (params, token)  => {
  // let headers = getSignHeader(params)
  // const res =  await wechatLauncherPlatformService.get(`/api/platform/user/info/by/unionId/get`,  { params, headers})
  // return res.data
  let headers = createNewGatwaySignWx(params, 'get')
  headers.token = token
  const res =  await wechatDomainQL.get(`/rjhy-wechat-platform/api/platform/user/info/by/unionId/get`, { params, headers })
  return res.data
}
